import { GET, POST, DELETE } from '../request'

export const getOportunidadesMarketing = ({ mes }) =>
  GET('/api/core/marketing/oportunidad-marketing/list', { mes })

export const resincronizarOportunidades = () =>
  POST('/api/core/marketing/oportunidad-marketing/resync')

export const deleteOportunidad = id =>
  DELETE('/api/core/marketing/oportunidad-marketing', { id })
